/** ============================================================================
 * nav
 *
 * @version   1.0.0
 * @author    Sam Rankin <srankin@riester.com>
 * @copyright 2022 RIESTER
 * ========================================================================== */

import { isEmpty, isReduced, listen, matchWidths, getParentsUntil, resizeListener, css } from '../../utils';

const CLASS_NAME = 'hover';

export default {
	name: 'nav',
	/**
	 * Adds `.active` class to current menu item and its parents
	 */
	activeItem() {
		let windowPath = window.location.pathname;

		// windowPath = windowPath.slice(1);

		let activeLinks = document.querySelectorAll(`.menu-link[href$="${windowPath}"]`);

		activeLinks.forEach((link) => {
			let parents = getParentsUntil(link, '.nav');

			parents.map((el) => {
				if (el.classList.contains('subnav')) {
					el.classList.add('has-active-link');
				}
				if ('li' === el.tagName.toLowerCase()) {
					for (let i = 0; i < el.children.length; i++) {
						let itemChildren = el.children[i];
						if ('a' === itemChildren.tagName.toLowerCase() && itemChildren.classList.contains('menu-link') && !itemChildren.classList.contains('active')) {
							itemChildren.classList.add('active');
						}
					}
				}
			});
		});
	},
	/**
	 * Adds focus class
	 *
	 * @param {FocusEvent} event
	 */
	focusIn(event) {
		if (event.type === 'focus' || event.type === 'focusin') {
			let self = event.target;

			if (self.hasAttribute('data-bs-toggle')) {
				self.classList.add('focus');
			}
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.add('focus');
				}
				self = self.parentNode;
			}
		}
	},
	/**
	 * Removes focus class
	 *
	 * @param {FocusEvent} event
	 */
	focusOut(event) {
		if (event.type === 'blur' || event.type === 'focusout') {
			let self = event.target;

			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.remove('focus');
				}
				self = self.parentNode;
			}
		}
	},
	/**
	 * Opens a submenu
	 *
	 * @param {MouseEvent|FocusEvent} event
	 */
	openSubMenu(event) {
		let elem = event.target;
		let parent = 'li' !== elem.tagName.toLowerCase() ? elem.closest('.dropdown') : elem;
		let toggle = 'button' !== elem.tagName.toLowerCase() ? parent.querySelector(':scope>[data-bs-toggle="dropdown"]') : elem;
		let target = parent.querySelector(':scope>.dropdown-menu');

		if (!target.classList.contains('show')) {
			bootstrap.Dropdown.getOrCreateInstance(toggle).toggle();
			parent.classList.add(CLASS_NAME);
			bootstrap.Dropdown.clearMenus(event);
		}
	},
	/**
	 * Closes a submenu
	 *
	 * @param {MouseEvent|FocusEvent} event
	 */
	closeSubMenu(event) {
		let elem = event.target;
		let parent = 'li' !== elem.tagName.toLowerCase() ? elem.closest('.dropdown') : elem;
		let toggle = 'button' !== elem.tagName.toLowerCase() ? parent.querySelector(':scope>[data-bs-toggle="dropdown"]') : elem;
		let target = parent.querySelector(':scope>.dropdown-menu');

		if (target.classList.contains('show')) {
			bootstrap.Dropdown.getOrCreateInstance(toggle).toggle();
			parent.classList.remove(CLASS_NAME);
		}
	},
	closeMenuOnBlur() {
		// let elem,
		// 	topLevelEl = event.target;
		// while (!topLevelEl.classList.contains('dropdown-menu')) {
		// 	topLevelEl = topLevelEl.parentNode;
		// }
		// let menuID = topLevelEl.getAttribute('id');
		// let parent = 'li' !== elem.tagName.toLowerCase() ? elem.closest('.dropdown') : elem;
		// let toggle =
		// 	'button' !== elem.tagName.toLowerCase() ? parent.querySelector(':scope>[data-bs-toggle="dropdown"]') : elem;
		// let target = parent.querySelector(':scope>.dropdown-menu');
	},
	/**
	 * Adds focus event for links with no children and open submenus for those
	 * that have them
	 */
	addToggleFocus() {
		const focusIn = this.focusIn;
		const focusOut = this.focusOut;
		const openSubMenu = this.openSubMenu;
		const closeSubMenu = this.closeMenuOnBlur;
		// Get all the link elements within the menu that don't have children.
		const links = document.querySelectorAll('li:not(.has-children) > .menu-link');
		links.forEach((link) => {
			link.addEventListener('focus', focusIn, true);
			link.addEventListener('blur', focusOut, true);
		});
		// Get all the toggle elements within the menu.
		// const dropdowns = document.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown');

		// dropdowns.forEach((toggle) => {
		// 	listen(toggle, 'focusout', closeSubMenu, true);
		// });

		const toggles = document.querySelectorAll('.menu-toggle');
		toggles.forEach((toggle) => {
			listen(toggle, 'focus', openSubMenu, true);
			listen(toggle, 'blur', closeSubMenu, true);
		});
	},
	/**
	 * Initialize navs
	 *
	 * Adds hover functionality to Bootstrap 5 navs
	 *
	 */
	initNav() {
		bootstrap.Dropdown.prototype.toggle = (function (_orginal) {
			return function () {
				document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
					e.classList.remove(CLASS_NAME);
				});
				let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
				for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
					dd.classList.add(CLASS_NAME);
				}
				return _orginal.call(this);
			};
		})(bootstrap.Dropdown.prototype.toggle);

		document.querySelectorAll('.dropdown').forEach(function (dd) {
			dd.addEventListener('hide.bs.dropdown', function (e) {
				if (this.classList.contains(CLASS_NAME)) {
					this.classList.remove(CLASS_NAME);
					e.preventDefault();
				}
				e.stopPropagation(); // do not need pop in multi level mode
			});
		});

		const openSubMenu = this.openSubMenu;
		const closeSubMenu = this.closeSubMenu;

		// for hover
		document.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown').forEach(function (dd) {
			let parent = dd;
			hoverintent(
				dd,
				function (e) {
					parent.classList.add(CLASS_NAME);
					openSubMenu(e);
				},
				function (e) {
					parent.classList.remove(CLASS_NAME);
					closeSubMenu(e);
				}
			).options({
				timeout: 300,
				interval: 200,
				sensitivity: 10,
				//handleFocus: true,
			});
		});
	},
	initMobileNav() {
		var mobileNav = document.getElementById('mobile-nav');
		const body = document.body;
		matchWidths('#mobile-login-toggle, #mobile-nav-toggle');

		if (!isEmpty(mobileNav)) {
			mobileNav.addEventListener('show.bs.offcanvas', function () {
				body.style.position = 'fixed';
				$('#mobile-nav-toggle').addClass('active');
				if (!isReduced) {
					anime({
						targets: '#mobile-nav .top-level-menu-item',
						translateY: ['+=10px', 0],
						opacity: [0, 1],
						easing: 'easeOutQuart',
						delay: anime.stagger(100), // increase delay by 100ms for each elements.
					});
				}
			});

			mobileNav.addEventListener('hide.bs.offcanvas', function () {
				$('#mobile-nav-toggle').removeClass('active');
				body.style.position = '';
				if (!isReduced) {
					anime({
						targets: '#mobile-nav .top-level-menu-item',
						translateY: [0, '+=10px'],
						opacity: [1, 0],
						easing: 'easeInQuart',
						delay: anime.stagger(100, { direction: 'reverse' }), // increase delay by 100ms for each elements.
					});
				}
			});
		}

		var mobileLogin = document.getElementById('login');
		if (!isEmpty(mobileLogin)) {
			mobileLogin.addEventListener('show.bs.offcanvas', function () {
				$('#mobile-login-toggle').addClass('active');

				body.style.position = 'fixed';
				if (!isReduced) {
					anime({
						targets: '#login .selected .form-group',
						translateY: ['+=10px', 0],
						opacity: [0, 1],
						easing: 'easeOutQuart',
						delay: anime.stagger(100), // increase delay by 100ms for each elements.
					});
				}
			});

			mobileLogin.addEventListener('hide.bs.offcanvas', function () {
				$('#mobile-login-toggle').removeClass('active');
				body.style.position = '';
				if (!isReduced) {
					anime({
						targets: '#login .selected .form-group',
						translateY: [0, '+=10px'],
						opacity: [1, 0],
						easing: 'easeInQuart',
						delay: anime.stagger(100, { direction: 'reverse' }), // increase delay by 100ms for each elements.
					});
				}
			});
		}
	},
	toggleOffcanvas() {
		resizeListener(
			() => {
				$('.offcanvas-item').unwrap('#primary-navbar .offcanvas .offcanvas-body');
				$('.offcanvas-item').unwrap('#primary-navbar .offcanvas');
				$('#primary-navbar > .container > .offcanvas-item .dropdown-toggle').attr('data-bs-toggle', 'dropdown');

				$('#primary-navbar > .container > .offcanvas-item .menu-item.has-children').addClass('dropdown');
				$('#primary-navbar > .container > .offcanvas-item .menu-item.has-children').removeAttr('aria-controls');
				$('#primary-navbar > .container > .offcanvas-item .menu-item.has-children').removeAttr('data-bs-target');
				$('#primary-navbar > .container > .offcanvas-item .subnav').addClass('dropdown-menu').removeClass('collapse');
				$('#util-nav').insertBefore('#search-form');

				$('#login').removeAttr('aria-modal');
			},
			() => {
				$('#primary-navbar > .container > .offcanvas-item .dropdown-toggle').attr('data-bs-toggle', 'collapse');
				$('#primary-navbar > .container > .offcanvas-item .menu-item.has-children').removeClass('dropdown');
				$('#primary-navbar > .container > .offcanvas-item .menu-toggle').each(function () {
					var cssID = $(this).attr('id');
					cssID = cssID.replace('-btn', '');
					$(this).attr('aria-controls', cssID);
					$(this).attr('data-bs-target', `#${cssID}`);
				});
				$('#primary-navbar > .container > .offcanvas-item .subnav').removeClass('dropdown-menu').addClass('collapse');
				$('#primary-navbar > .container > .offcanvas-item').wrapAll('<div class="mobile-nav offcanvas offcanvas-start" aria-modal="true" tabindex="-1" data-bs-backdrop="false" id="mobile-nav"><div class="offcanvas-body container"></div></div>');

				$('#util-nav').insertAfter('#primary-nav');
				$('#login').attr('aria-modal', 'true');
			},
			'lg'
		);
	},
	addHeaderMarginToNav() {
		const header = document.getElementById('masthead');
		resizeListener(
			() => {
				css('.mobile-nav', {
					marginTop: 0,
				});
			},
			() => {
				let headerRect = header.getBoundingClientRect();

				css('.mobile-nav', {
					marginTop: headerRect.height + 'px',
				});
			},
			'lg'
		);
	},
	init() {},
	finalize() {
		this.toggleOffcanvas();
		this.addHeaderMarginToNav();
		this.activeItem();
		this.initNav();
		this.initMobileNav();
		this.addToggleFocus();
	},
	resize() {},
};
